<div id="witnessLogin" class="modal is-touch is-short" (transitionend)="setDefaultFocus($event)"
  [ngClass]="{ 'is-open': (isVerifyWitnessModalOpen | async)}">
  @if (isVerifyWitnessModalOpen | async) {
    <div id="witnessLoginDiv" class="modal__content">
      <div id="witnessLoginHeader" class="modal__header pb0 h2">
        Verify Witness
      </div>
      <div class="modal__body flex justify-content-around overflow-visible">
        <div class="touch-table__table-wrapper mr2">
          <div class="touch-table mr1 mb0 witness-credentials-card-height">
            <div class="row no-gutters">
              <table id="formControlTable">
                <thead>
                  <tr>
                    <th class="left">
                      <div id="witnessLoginLocationLbl">Location</div>
                      <div id="witnessLoginPositionLbl">Position</div>
                    </th>
                    <th></th>
                    <th class="left table--fill-remaining-width width100 flex align-center justify-content-between">
                      <div>
                        <div id="witnessLoginItemLbl">Item</div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of gridWitnessLoginItems | paginate: witnessLoginPagingConfig; track trackItem(i, item); let i = $index) {
                    <tr id="witnessLoginItem{{i}}">
                      <td>
                        <div id="witnessLoginItemDoor{{i}}" class="drug-name--primary">{{item.doorName}}</div>
                        <div id="witnessLoginItemPosition{{i}}" class="drug-name--alternate">{{item.positionName}}</div>
                      </td>
                      <td class="table-alert__wrapper pr0">
                        <absg-icons [customId]="'witLoginIcons'+i" [isAuditFavorite]="false" [iconProvider]="item"
                          [suppressFavoriteIcon]="item?.isBinItem"></absg-icons>
                      </td>
                      <td class="table--fill-remaining-width">
                        <div class="flex align-center justify-content-between py1">
                          <div>
                            <div class="drug-name--primary truncate--single">
                              <div id="witnessLoginItemDisplayName{{i}}">{{item.getProductDisplayName()}}</div>
                            </div>
                            @if (!item.isBinned() && !item.isPatientOwned) {
                              <div class="drug-name--alternate h4 truncate--single">
                                <div id="witnessLoginItemAltName{{i}}">{{item.alternateName}}</div>
                              </div>
                            }
                            @if (item.isPatientOwned) {
                              <div class="drug-name--alternate truncate--single">
                                <div id="witnessLoginItemPatientInfo-{{i}}">
                                  <span class="h6 bold gray-15">{{item.patientOwnedItemTypeShortName}}</span>
                                  {{item.getPatientOwnedDemographics()}}
                                </div>
                              </div>
                            }
                            <absg-status-pills id="witnessLoginsWitnessPill{{i}}" [customId]="i" [statusProvider]="item" [isWitness]="true"
                              [maxPillCountOnPage]="3" (showAllPills)="showAllPills($event)" [suppressDiscontinuedItem]="item?.isBinItem"
                              [suppress505b2Pill]="item?.isBinItem" [suppress340BPill]="item?.isBinItem"
                              [suppressBuyInPill]="item?.isBinItem"></absg-status-pills>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <ul class="touch-pagination">
            <div nc-pagination-controls [config]="witnessLoginPagingConfig"></div>
          </ul>
        </div>
        <div class="modal__card witness-credentials-card-height flex flex-column align-center border border-navy-87">
          <absg-spinner id="witnessLoginSpinner" [show]="isSpinnerVisible$ | async"></absg-spinner>
          <div class="container flex flex-column justify-content-between height100 px1">
            <form [formGroup]="verifyWitnessForm">
              <div>
                <div id="witnessCredentials" class="h3 pb3">Witness Credentials</div>
                <div class="form-group">
                  <label for="itemType" class="h5 required-label">User Name</label>
                  <input id="witnessLoginUserName" #txtUserName type="text" class="form-control required is-focus"
                    [ngClass]="{'is-error': popupSameUserNameValidationError || popupInvalidUserError || popupWitnessPermissionErrorMessage}"
                    [formControl]="verifyWitnessUserNameControl" (blur)="onBlur($event)">
                  @if (popupSameUserNameValidationError || popupInvalidUserError || popupWitnessPermissionErrorMessage) {
                    <div class="touch-error__wrapper">
                      <div id="witnessLoginUserNameErrorMessage" class="touch-error">
                        {{userNameErrorMessage}}
                      </div>
                    </div>
                  }
                </div>
                <div class="form-group mt2 pb3">
                  <label for="itemType" class="h5 required-label">Password</label>
                  <input type="password" id="witnessLoginPassword" class="form-control required" [ngClass]="{'is-error': popupInvalidUserError}"
                    [formControl]="verifyWitnessPasswordControl">
                </div>
              </div>
              <div class="flex justify-content-between mt3">
                <button id="witnessLoginCancelButton" type="button" class="btn btn--true-blue-inverse"
                  (click)="onCancelVerifyWitnessModal($event)">Cancel</button>
                <div class="flex">
                  <button id="witnessLoginVerifyWitnessButton" class="btn btn--true-blue ml2" [disabled]="!isVerifyWitnessButtonEnabled()"
                    (click)="onVerifyWitnessButtonClicked($event)">Verify Witness</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div id="witnessPillComponentModal" nc-station-pill-component [pillItem]="displayPillItem" [isPillModalOpen]="isPillModalOpen"
  (closeModalEvent)="closeModalEvent($event)"></div>